module.exports = __webpack_public_path__ + "img/serrote e tesoura poda.a99cbc97.webp";